import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getContent = () => api.get("/content").then((r) => r.data);

export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);

export const loginAdmin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);

export const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("csm_token") || ""}` },
});

export const getMe = () => api.get("/auth/me", authHeaders()).then((r) => r.data);
export const getLeads = () => api.get("/leads", authHeaders()).then((r) => r.data);
export const deleteLead = (id) => api.delete(`/leads/${id}`, authHeaders()).then((r) => r.data);
export const saveContent = (content) => api.put("/content", content, authHeaders()).then((r) => r.data);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return "Terjadi kesalahan. Silakan coba lagi.";
}
